import React from 'react';
import { connect } from 'react-redux';
import { PageLoader, TabContainer } from '@kambria/kambria-lego';
import LoadingButton from 'views/components/LoadingButton';
import { getKWalletHistory } from 'redux/actions/kWallet.action';
import Utils from 'helpers/utils';
import enums from 'helpers/const';

const { HISTORY_TYPE } = enums;
const INITAL_LIMIT = 5;
const PAGE = 1;
const REJECTED_WITHDRAW = 'Rejected withdraw request';

class KatKyte extends React.Component {
  componentDidMount() {
    const { getKWalletHistory: getKWalletHistoryList, type, katWallet, kyteWallet } = this.props;
    const { page = PAGE } = type === HISTORY_TYPE.KAT ? katWallet.pagination : kyteWallet.pagination;
    getKWalletHistoryList({ limit: INITAL_LIMIT, page, type });
  }

  onLoadMore = () => {
    const { type, getKWalletHistory: getKWalletHistoryList, katWallet, kyteWallet } = this.props;
    const { page } = type === HISTORY_TYPE.KAT ? katWallet.pagination : kyteWallet.pagination;
    return getKWalletHistoryList({
      limit: INITAL_LIMIT,
      page: page + 1,
      type,
    });
  };

  getDescription = (history) => {
    const { additionalData, note, activity } = history;

    if (!additionalData) {
      return note ? <span>{note}</span> : null;
    }

    const {
      productId,
      productName,
      name,
      revenueSharing,
      edukationURL,
      address,
      requestDate,
      depositDate,
      bountyId,
      bountyName,
    } = additionalData;
    let href;
    let text;
    let subtext = '';
    if (bountyId) {
      href = `/bounty/${bountyId}`;
      text = bountyName || 'this activity';
    }
    if (productId && edukationURL) {
      href = edukationURL;
      text = productName || name;
      if (revenueSharing) {
        subtext = ` with revenue Sharing is ${revenueSharing}%`;
        if (activity === 'SUBSCRIPTION') {
          subtext = ` with Hybrid revenue sharing (${revenueSharing}% or 40% per Partner’s EdVid / Total EdVids)`;
        }
      }
    }
    if (address && (requestDate || depositDate)) {
      text = address;
    }
    return (
      <span>
        {`${note}: `}
        <a href={href} target="_blank" rel="noopener noreferrer">
          {text}
        </a>
        {subtext}
      </span>
    );
  };

  rederContent = () => {
    const { katWallet, kyteWallet, type } = this.props;
    const style = {
      whiteSpace: 'nowrap',
    };
    const { history } = type === HISTORY_TYPE.KAT ? katWallet : kyteWallet;
    return history.map((item, index) => {
      console.log('Item:', item);
      return (
        <tr key={index}>
          <td className="w-25 pr-2" style={style}>
            {new Date(item.createdAt).toDateString().slice(4)}
          </td>
          <td className="w-25 pr-2" style={style}>
            {Utils.formatNumber(item.amount)}
            {item.additionalData.action.includes(REJECTED_WITHDRAW) && (
              <p style={{ color: 'orange', fontSize: 12, fontWeight: '600' }}>REJECTED</p>
            )}
          </td>
          <td className="w-100 pr-2">{this.getDescription(item)}</td>
        </tr>
      );
    });
  };

  render() {
    const { katWallet, kyteWallet, type, loading } = this.props;
    const { history, pagination } = type === HISTORY_TYPE.KAT ? katWallet : kyteWallet;
    const { limit, total, page } = pagination;
    const showLoadMore = limit * page < total;
    if (!history.length && loading)
      return (
        <div className="tab-content">
          <TabContainer className="container px-0 mt-3">
            <div className="table-responsive">
              <PageLoader type="position" />
            </div>
          </TabContainer>
        </div>
      );
    return (
      <div className="tab-content">
        <TabContainer className="container px-0 mt-3">
          <div className="table-responsive">
            <table className="w-100 table">
              <thead>
                <tr>
                  <th className="pr-2" scope="col">
                    Date
                  </th>
                  <th className="pr-2" scope="col" style={{ width: '13%' }}>
                    Value
                  </th>
                  <th className="pr-2" scope="col" style={{ width: '70%' }}>
                    Description
                  </th>
                </tr>
              </thead>
              <tbody>{this.rederContent()}</tbody>
            </table>
          </div>
          {showLoadMore && (
            <div style={{ textAlign: 'center' }}>
              <LoadingButton onClick={this.onLoadMore} loading={loading} variant="gray" size="sm">
                Load more
              </LoadingButton>
            </div>
          )}
        </TabContainer>
      </div>
    );
  }
}

const mapStateToProps = ({ kWallet }) => ({
  katWallet: kWallet.katWallet,
  kyteWallet: kWallet.kyteWallet,
  loading: kWallet.loadingKWallet,
});

export default connect(mapStateToProps, { getKWalletHistory })(KatKyte);
